
import React from 'react';

import { Box, Text } from 'grommet';

const DataDoesNotExist = () => {
    return (
        <Box background="light-2" pad="small" fill>
            <Text>Data nejsou k dispozici</Text>
        </Box>
    );
}

export default DataDoesNotExist;
